import { render, staticRenderFns } from "./ModalMatriculas.vue?vue&type=template&id=19a64003&scoped=true&"
import script from "./ModalMatriculas.vue?vue&type=script&lang=js&"
export * from "./ModalMatriculas.vue?vue&type=script&lang=js&"
import style0 from "./ModalMatriculas.vue?vue&type=style&index=0&id=19a64003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a64003",
  null
  
)

export default component.exports